import { defineTapPropertyExtension } from '@iotize/tap';

import { TapEncryption } from './tap-encryption';

declare module '@iotize/tap/lib/tap' {
  interface Tap {
    encryption: TapEncryption;
  }
}

export const _TAP_EXTENSION_ENCRYPTION_ = defineTapPropertyExtension(
  'encryption',
  (context) => new TapEncryption(context.tap),
);
